import { apiClient } from '@/http/apiClient';
import { buildQuery } from '@/http/url';
const rootPath = 'Coefficients';

class CoefficientService {
    
    // public async getCoefficientTypes(bopModelId:string,isLinkedToOperationPrincipal:boolean,isCoefficient:boolean,isLinkedToOperationDiverse:boolean,lang:string): Promise<any> {
    //     return apiProvider.get(`${apiProvider.getUrl()}${rootPath}${toUrl({lang , bopModelId,isLinkedToOperationPrincipal,isCoefficient,isLinkedToOperationDiverse})}`);
    // }
    public async getConfigurableCoefficientTypes(bopModelId:string,lang:string): Promise<any> {
        return apiClient.get(`${rootPath}/configurableCoefficients${buildQuery({lang , bopModelId})}`);
    }
    public async getOperationPrincipaleCoefficients(bopModelId:string,lang:string): Promise<any> {
        return apiClient.get(`${rootPath}/operationPrincipaleCoefficients${buildQuery({lang , bopModelId})}`);
    }
    
    public async getCoefficientByKeyAndBopModel(bopModelId:string,coefficientKey:string,lang:string): Promise<any> {
        return apiClient.get(`${rootPath}/byKeyandBopModel${buildQuery({coefficientKey , bopModelId,lang})}`);
    }

    // public async getOperationDiverseCoefficients(bopModelId:string,lang:string): Promise<any> {
    //     return this.getCoefficientTypes(bopModelId,false,false,true,lang);
    // }
    public async getBopModelCoefficientTypes(bopModelId:string,lang:string): Promise<any> {
        return apiClient.get(`${rootPath}${buildQuery({lang , bopModelId})}`);
    }
    public async getCoefficientByTypeAndBopModel(bopModelId:string,coefficientType:number,lang:string): Promise<any> {
        return apiClient.get(`${rootPath}${buildQuery({lang , bopModelId,coefficientType})}`);
    }
    public async getExceptionCoefficientTypes(bopModelId:string,lang:string): Promise<any> {
        return apiClient.get(`${rootPath}/exceptionCoefficientTypes${buildQuery({lang , bopModelId})}`);
    }
    
    public async getExceptionCoefficientConfigTypes(bopModelId:string,lang:string): Promise<any> {
        return apiClient.get(`${rootPath}/exceptionCoefficientConfigTypes${buildQuery({lang , bopModelId})}`);
    }

    public async getCoefficientById(coefficientId:string): Promise<any> {
        return apiClient.get(`${rootPath}/${coefficientId}`);
    }
    
}

export default new CoefficientService();